import {dataFetcher} from "../../services/dataGuetter/dataFetcher";

export function getAlerteCentre(id:number):Promise<AlerteCentre>{
    return dataFetcher(`alerte_centres/${id}`, {method:'get'})
}